import "./style.css";
import { App } from "./app/App";
import { announceBuildToServiceWorker, registerServiceWorker } from "./sw/registerServiceWorker";
import { BuildWatcher, entryOf, fetchBuildVersion, showUpdateToast } from "./app/buildWatcher";
import { config } from "./config";

const root = document.getElementById("app");
if (!root) {
  throw new Error("missing #app root element");
}

const app = new App(root);
app.mount();

// FIX3: a tab must never keep running an old bundle against new data. The
// entry chunk this code was loaded from IS the build identity; `version.json`
// (written at build time, served no-cache) names the deployed one. Production
// only — the dev server has no version.json and no hashed entry.
const currentEntry = import.meta.env.PROD ? entryOf(import.meta.url) : null;
void registerServiceWorker().then((registration) => {
  if (registration !== null && currentEntry !== null) {
    void announceBuildToServiceWorker(currentEntry, import.meta.url);
  }
});
if (currentEntry !== null) {
  let sessionStore: Storage | null = null;
  try {
    sessionStore = window.sessionStorage;
  } catch {
    sessionStore = null;
  }
  new BuildWatcher({
    currentEntry,
    fetchVersion: () => fetchBuildVersion(import.meta.env.BASE_URL),
    reload: () => window.location.reload(),
    notify: (message) => void showUpdateToast(message),
    storage: sessionStore,
    intervalMs: config.pollIntervalMs,
  }).start();
}

// Exposed for the Playwright smoke test and manual debugging only — never
// read by any panel itself (no side channel back into rendering logic).
declare global {
  interface Window {
    __obsApp?: App;
    __obsBrainProjectedBounds?: () => BrainProjectedBounds | null;
    __obsBrainCameraDistance?: () => number | null;
  }
}
window.__obsApp = app;

/** Debug-only shape mirroring `BrainScene.projectedScreenBounds` — kept as a
 * plain structural type here so `main.ts` doesn't need a `BrainScene`
 * import just for this. */
interface BrainProjectedBounds {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
  canvasWidth: number;
  canvasHeight: number;
}

// The brain camera-fit debug hooks (required outcome (e)) are gated behind
// an explicit query flag — `?debugBrainFit=1` — rather than always exposed
// like `__obsApp` above: unlike `__obsApp` (a stable reference the app
// already builds regardless), these two read live camera/projection state
// specifically for the Playwright fit-regression tests, so they stay off by
// default and only turn on when a test opts in.
if (new URLSearchParams(window.location.search).get("debugBrainFit") === "1") {
  window.__obsBrainProjectedBounds = () =>
    app.currentOrganismScreen?.brainPanel?.projectedBounds() ?? null;
  window.__obsBrainCameraDistance = () =>
    app.currentOrganismScreen?.brainPanel?.cameraDistance() ?? null;
}
